module.exports = __webpack_public_path__ + "static/media/tribevibe-drumbeat-logo-208.622aeb46.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tribevibe-drumbeat-logo-208.png
// module id = 1324
// module chunks = 0